<template>
	<div class="home">
		<div class="top">
			<span class="title">化学原料药</span>
			<div>
				<tq-input 
					v-model="search" 
					class="input" 
					type="text"
					:maxlength="100"
					placeholder="请输入中文名称/英文名称/CAS号">
					<template #prefix>
						<img src="../../assets/search.svg" alt="icon" class="input-icon">
					</template>
					<template #suffix>
						<img
							v-if="search"
							src="../../assets/delete.svg" alt="icon"
							class="input-icon-delete"
							@click="deleteword">
						<span class="inputbutton" @click="() => fetchData({ pageNo: 1, pageSize: pageSize })">搜索</span>
					</template>
				</tq-input>
			</div>
		</div>
		<div class="table">
			<tq-list-view
				:total-records="total"
				:page-num="currentPage"
				:page-size="pageSize"
				hidden-search
				:init-load-data="true"
				:page-sizes="[10, 20, 30, 40, 50]"
				@query-list="fetchData">
				<template #table>
					<tq-table
						:data="tableData" :columns="columns"
						:loading="loading"
						@row-click="handleRowClick" />
				</template>
			</tq-list-view>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { getActiveTableData } from "../../apis/interfaces/tables";
// 需要从 Element Plus 导入表格组件
import { ElMessage } from "element-plus";
// import router from "../../pages/index/router";


// 新闻数据
interface TableItem {
  chineseName: string
  englishName: string
  casNumber: string
  qualityStandard: string
  productStatus: string
}
const tableData = ref<TableItem[]>([]);

const columns = ref([
	{
		prop: "chineseName",
		label: "中文名称"
	},
	{
		prop: "englishName",
		label: "英文名称"
	},
	{
		prop: "casNumber",
		label: "CAS号"
	},
	{
		prop: "qualityStandard",
		label: "质量标准"
	},
	{
		prop: "productStatus",
		label: "产品状态"
	}
]);
onMounted(() => {
	fetchData({ pageNo: 1, pageSize: pageSize.value });
});
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const search = ref("");
const loading = ref(true);
let records = ref([]);
const fetchData = async (params: any) => {
	console.log("activeapi");
	console.log("pageSizeCount:", params);
  
	loading.value = true;
	try {
		const res = await getActiveTableData({
			keyWord: search.value,
			pageNum: params.pageNo,
			pageSize: params.pageSize
		});
		console.log(res);
		if(res?.msgCode === "100"){
			console.log("res:", res);
			records.value = res?.responseData?.records || [];
			total.value = res?.responseData?.total || 0;
			if(records.value.length === 0){
				tableData.value = [];
			}else{
				tableData.value = records.value?.map((item: any) => {
					return {
						chineseName: item.chineseName || "",
						englishName: item.englishName || "",
						casNumber: item.casNumber || "",
						qualityStandard: item.qualityStandard || "",
						productStatus: item.productStatus || ""
					}; 
				});
			}
			console.log("tableData:", tableData.value);
		}else{
			ElMessage.error(res?.message);
		}
	} catch (error) {
		console.error("获取数据失败:", error);
		tableData.value = [];
		total.value = 0;
	} finally {
		loading.value = false;
	}
};
const router = useRouter();
import { useConfigStore } from "@/stores/index.ts";
const store = useConfigStore();
const deleteword = () => {
	search.value = "";
};
const handleRowClick = (row: TableItem, column: any, event: Event) => {
	// 查找原始数据中的完整记录
	const fullRecord = records.value.find(item => {
		return item.chineseName === row.chineseName && 
		item.englishName === row.englishName && 
		item.casNumber === row.casNumber; 
	}
	);
	console.log("点击的行数据:", row, fullRecord);
	// 将新闻详情存储到store中
	store.setMaterialDetail(fullRecord);
	router.push({
		path: "/products/activeDetail"
	});
};
</script>

<script lang="ts">
export default {
	name: "ActivePi"
};
</script>

<style lang="styl" scoped>
.home {
  width: 100%;
  min-height: calc(100% - 90px);
  background-color: #fff;
}
.home .top{
  display: flex;
  flex-direction: column;
  align-items: center; 
}
.home .title {
  height: 23px;
  font-weight: 500;
  font-size: 23px;
  color: #252525;
  line-height: 23px;
  margin-top: 65px;
}
.home .input {
  margin: 36px 0 35px 0;
  width: 35%;
  height: 50px;
  min-width: 600px;
}
.input-icon-delete { 
	margin-right: 10px;
	height: 12px;
}
.home .input .inputbutton{
  width: 29px;
  height: 15px;
  font-weight: 400;
  font-size: 15px;
  color: #0659A4;
  line-height: 15px;
  cursor: pointer;
}

.home .table {
  width: 70%;
  min-width: 1000px;
  margin: 0 auto;
  margin-bottom: 20px;
}
:deep(.el-table__empty-block) {
  height: 200px !important;
  min-height: 200px !important;
}
/* 表头 */
:deep(.el-table th) {
  background-color: #0659A4 !important;
  height: 49px;
}
/* 表格竖线 */
:deep(.el-table__row td) {
  border: none !important;
}

:deep(.el-table__header-wrapper th) {
  border: none !important;
}
/* 表头文字 */
:deep(.el-table th.el-table__cell.tq-table-header) {
  color: #FFFFFF !important;
  font-weight: 500;
  font-size: 15px !important;
  line-height: 20px;
  font-style: normal;
}
:deep(.el-table) {
  font-size: 15px;
}
:deep(.el-table__row){
  border: 8px 0 !important;
  cursor: pointer;
}
:deep(.el-table .el-table__row) {
  height: 72px;
}
</style>
